import React  from 'react';
import { LoggerServices } from '../../services';
import { ErrorTemplate } from './errorTemplate';

class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { error: null, errorInfo: null };
    }
    
    componentDidCatch(error, errorInfo) {
      // Catch errors in any components below and re-render with error message
      this.setState({
        error: error,
        errorInfo: errorInfo
      });
      // You can also log error messages to an error reporting service here
      LoggerServices.print(errorInfo, error);
    }
    
    render() {
      if (this.state.errorInfo) {
        return (<ErrorTemplate errorInfo ={this.state.errorInfo} error ={this.state.error}/>
        );
      }
      return this.props.children;
    }  
  }


  export default ErrorBoundary;
